import React, { memo } from 'react';
import { Handle, Position } from 'reactflow';
import { Box, Paper, Typography, Chip, Avatar } from '@mui/material';
import {
  Settings as ActionIcon,
  Task as TaskIcon,
  Email as EmailIcon,
  Notifications as NotificationIcon,
  Api as ApiIcon,
  Person as UserIcon
} from '@mui/icons-material';

const getIcon = (subtype) => {
  switch (subtype) {
    case 'create_task':
    case 'update_field':
      return <TaskIcon fontSize="small" />;
    case 'send_email':
      return <EmailIcon fontSize="small" />;
    case 'send_notification':
      return <NotificationIcon fontSize="small" />;
    case 'webhook':
      return <ApiIcon fontSize="small" />;
    case 'assign_to':
      return <UserIcon fontSize="small" />;
    default:
      return <ActionIcon fontSize="small" />;
  }
};

const ActionNode = ({ data, selected }) => {
  return (
    <Paper
      elevation={selected ? 8 : 2}
      sx={{
        padding: '12px 16px',
        borderRadius: 2,
        border: '2px solid',
        borderColor: selected ? 'primary.main' : '#2196f3',
        backgroundColor: selected ? 'primary.light' : '#e3f2fd',
        minWidth: 180,
        transition: 'all 0.2s'
      }}
    >
      <Handle
        type="target"
        position={Position.Top}
        style={{
          background: '#2196f3',
          width: 10,
          height: 10
        }}
      />
      
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
        <Avatar
          sx={{
            width: 28,
            height: 28,
            backgroundColor: '#2196f3',
            color: 'white'
          }}
        >
          {getIcon(data.config?.subtype)}
        </Avatar>
        <Typography variant="caption" sx={{ color: '#2196f3', fontWeight: 600 }}>
          ACTION
        </Typography>
      </Box>
      
      <Typography variant="body2" sx={{ fontWeight: 500, mb: 0.5 }}>
        {data.label || 'Action'}
      </Typography>
      
      {data.config?.description && (
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
          {data.config.description}
        </Typography>
      )}
      
      {data.config?.subtype && (
        <Chip
          label={data.config.subtype.replace(/_/g, ' ')}
          size="small"
          sx={{ mt: 1, height: 20 }}
        />
      )}
      
      <Handle
        type="source"
        position={Position.Bottom}
        style={{
          background: '#2196f3',
          width: 10,
          height: 10
        }}
      />
    </Paper>
  );
};

export default memo(ActionNode);